import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup } from 'reactstrap';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
import { PostEnableDisableTempAdjustments } from '../../../../../action/temperatureAdjustmentsAction';


 class ChangeLimits extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected_zones: this.props.parentToChildData,
            minimum_temp: null,
            maximum_temp: null,
            error_msg: false,
            higher_lower_error_msg: false,
        };
        this.Submit = this.Submit.bind(this);
        this.returnToView = this.returnToView.bind(this);
        this.displayError = this.displayError.bind(this);
        this.higherloweError = this.higherloweError.bind(this);
    }


    displayError() {
        this.setState({
            error_msg: true,
        });
    }
    higherloweError() {
        this.setState({
            higher_lower_error_msg: true,
        });
    }


    returnToView() {
        this.props.toggle();
    }


    /* Submit fixed charges data */

    Submit(event) {

        event.preventDefault();
        this.setState({ error_msg: false,higher_lower_error_msg:false },()=>{
           
            var Data = {
                "zones": this.state.selected_zones,
                "enableAdjustment": true,
                "minimumLimit": this.state.minimum_temp,
                "maximumLimit": this.state.maximum_temp
            }
    
            if (Data.minimumLimit !== null && Data.maximumLimit !== null) {
                if( parseInt(Data.maximumLimit) >  parseInt(Data.minimumLimit)){
                    // this.setState({ error_msg: false,higher_lower_error_msg: false});
                   this.props.PostEnableDisableTempAdjustments(Data);
                    this.returnToView();
                }
                else{
                    this.setState({ error_msg: false,higher_lower_error_msg: true});
                }
            }
            else {
                this.setState({ error_msg: true,higher_lower_error_msg: false});
            }
        });
    }



    render(getLabels) {
        let Error_Message,HL_Error_Message = null;
        let label = this.props.getLabels;
        
        (this.state.error_msg === true) ?  Error_Message =  <p  className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.changeLimits_error}</p>  : Error_Message= "";
        (this.state.higher_lower_error_msg === true) ?  HL_Error_Message =  <p  className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.higherlower_error}</p>  : HL_Error_Message= "";

        return (
            <div className="ChangeLimits_Modal">
                <h4 className="Modal_form_title">{label['Requests.btnChangeLimit.Text']}</h4>
                {HL_Error_Message}
                {Error_Message}
                <div>
                    <label className="ChangeLimits_Modal_label">{label['TemperatureAdjustment.Columns.Minimum.Text']}</label>
                    <input ref='minimum_temp' type="number"  className="ChangeLimits_Modal_input default-input" onChange={e => this.setState({ minimum_temp: e.target.value })} /> <span className="temp_lbl"> °F</span>
                </div>

                <div className="Modal_form_group ">
                    <label className="ChangeLimits_Modal_label"> {label['TemperatureAdjustment.Columns.Maximum.Text']}</label>
                    <input ref='max_temp' type="number" className="ChangeLimits_Modal_input default-input" onChange={e => this.setState({ maximum_temp: e.target.value })} /><span className="temp_lbl"> °F</span>
                </div>

                <FormGroup row >
                    <Col sm={{ size: 12 }}>
                        <Button className="btn-gray btn-md ChangeLimits_Cancelbtn" onClick={this.returnToView} > {label['Buttons.Cancel.Text']} </Button>
                        <Button className="btn-success btn-md ChangeLimits_Applybtn" onClick={this.Submit} >{label['Buttons.Apply.Text']}</Button>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        getLabels : state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        // GetTemperatureAdjustmentsList: () => dispatch(GetTemperatureAdjustmentsList()),
        PostEnableDisableTempAdjustments: (data) => dispatch(PostEnableDisableTempAdjustments(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLimits);



